(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ga-cart-conversion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ga-cart-conversion')) {
    class GaCartConversion extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      setStatus(message) {
        const status = this.querySelector('.ga-cart-conversion__status');
        if (status) status.textContent = message;
      }

      sectionInnerHTML(html, selector) {
        if (!html) return null;
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        return documentFragment.querySelector(selector);
      }

      updateCartPage(parsedState) {
        const mainItems = document.getElementById('main-cart-items');
        const mainFooter = document.getElementById('main-cart-footer');
        const cartIcon = document.getElementById('cart-icon-bubble');
        const cartDrawer = document.querySelector('cart-drawer');

        if (mainItems?.dataset.id && parsedState.sections?.[mainItems.dataset.id]) {
          const source = this.sectionInnerHTML(parsedState.sections[mainItems.dataset.id], '.js-contents');
          const target = mainItems.querySelector('.js-contents');
          if (source && target) target.innerHTML = source.innerHTML;
        }

        if (mainFooter?.dataset.id && parsedState.sections?.[mainFooter.dataset.id]) {
          const source = this.sectionInnerHTML(parsedState.sections[mainFooter.dataset.id], '.js-contents');
          const target = mainFooter.querySelector('.js-contents');
          if (source && target) target.innerHTML = source.innerHTML;
        }

        if (cartIcon && parsedState.sections?.['cart-icon-bubble']) {
          const source = this.sectionInnerHTML(parsedState.sections['cart-icon-bubble'], '.shopify-section');
          if (source) cartIcon.innerHTML = source.innerHTML;
        }

        if (cartDrawer && parsedState.sections?.['cart-drawer']) {
          const source = this.sectionInnerHTML(parsedState.sections['cart-drawer'], '#CartDrawer');
          const target = cartDrawer.querySelector('#CartDrawer');
          if (source && target) {
            target.innerHTML = source.innerHTML;
            const overlay = target.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
          }
        }
      }

      async handleClick(event) {
        const button = event.target.closest('[data-ga-add]');
        if (!button || !this.contains(button) || button.disabled) return;

        event.preventDefault();
        const originalText = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = button.dataset.addingText;
        this.setStatus('');

        try {
          const mainItems = document.getElementById('main-cart-items');
          const mainFooter = document.getElementById('main-cart-footer');
          const sectionIds = ['cart-drawer', 'cart-icon-bubble'];

          if (mainItems?.dataset.id) sectionIds.push(mainItems.dataset.id);
          if (mainFooter?.dataset.id) sectionIds.push(mainFooter.dataset.id);

          const formData = new FormData();
          formData.append('id', button.dataset.variantId);
          formData.append('quantity', '1');
          formData.append('sections', [...new Set(sectionIds)].join(','));
          formData.append('sections_url', window.location.pathname);

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const response = await fetch(routes.cart_add_url, config);
          const parsedState = await response.json();

          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || button.dataset.errorText);
          }

          const cartDrawer = document.querySelector('cart-drawer');
          if (this.closest('cart-drawer') && cartDrawer?.renderContents) {
            cartDrawer.renderContents(parsedState);
          } else {
            this.updateCartPage(parsedState);
          }
        } catch (error) {
          this.setStatus(button.dataset.errorText);
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = originalText;
        }
      }
    }

    customElements.define('ga-cart-conversion', GaCartConversion);
  }
  } catch(e) { console.error(e); }
})();

})();
